const enum CardTypes {
  VirtualCard = 'virtualCardAbb',
  DebtCard = 'debtCardAbb',
}

const defaultUrlSearchParamsMap = new Map([['cardType', CardTypes.VirtualCard]]);

export default function getCardType() {
  const searchParams =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : defaultUrlSearchParamsMap;
  const cardType = searchParams.get('cardType') || CardTypes.VirtualCard;

  return cardType;
}
